var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-page-content-wrapper features" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.languageTimeZone"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.languageSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "fields" },
        [
          _c("FeatureItem", {
            attrs: {
              title: _vm.$t("message.clientDefault"),
              icon: "Language1",
              description: _vm.$t("message.vtipyClientDefault"),
              type: "select",
              options: _vm.languages.map(function (x) {
                return { id: x.code, label: x.name }
              }),
              "default-select-option-placeholder": _vm.$t(
                "message.selectALanguage"
              ),
            },
            model: {
              value: _vm.clientLanguage,
              callback: function ($$v) {
                _vm.clientLanguage = $$v
              },
              expression: "clientLanguage",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              title: _vm.$t("message.customerClientDefault"),
              icon: "Language2",
              description: _vm.$t("message.vtipyCustomerClientDefault"),
              type: "select",
              options: _vm.languages.map(function (x) {
                return { id: x.code, label: x.name }
              }),
              "default-select-option-placeholder": _vm.$t(
                "message.selectALanguage"
              ),
            },
            model: {
              value: _vm.customerClientLanguage,
              callback: function ($$v) {
                _vm.customerClientLanguage = $$v
              },
              expression: "customerClientLanguage",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              title: _vm.$t("settings.timeZoneTitle"),
              icon: "TimeZoneIcon",
              description: _vm.$t("settings.timeZoneDescription"),
              type: "select",
              options: _vm.timezones.map(function (x) {
                return { id: x, label: x }
              }),
              "default-select-option-placeholder": _vm.$t(
                "message.selectALanguage"
              ),
            },
            model: {
              value: _vm.defaultTimzezone,
              callback: function ($$v) {
                _vm.defaultTimzezone = $$v
              },
              expression: "defaultTimzezone",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtipyCustomerClientLanguageDetect"),
              title: _vm.$t("message.customerClientLanguageDetect"),
              icon: "Language3",
            },
            model: {
              value: _vm.customerClientLanguageDetect,
              callback: function ($$v) {
                _vm.customerClientLanguageDetect = $$v
              },
              expression: "customerClientLanguageDetect",
            },
          }),
          _vm._v(" "),
          _c("FeatureItem", {
            attrs: {
              description: _vm.$t("message.vtipyVisitorPreferredLang"),
              title: _vm.$t("message.visitorPreferredLang"),
              icon: "Language4",
            },
            model: {
              value: _vm.languageShow,
              callback: function ($$v) {
                _vm.languageShow = $$v
              },
              expression: "languageShow",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }